import { Component, OnInit, Input, Output, EventEmitter, Inject } from '@angular/core';

import { RequestInProgressService }  from '@trivelope/triv-ui-tools-lib';

import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { DataInput }  from '@trivelope/triv-ui-tools-lib';

import { FileInfo } from 'src/app/classes/fileInfo';
import { OldFileService } from 'src/app/services/file.old.service';
import { Environment } from 'src/app/classes/environment';


@Component({
	selector: 'app-file-editor',
	templateUrl: './file-editor.component.html',
	styleUrls: ['./editor.component.css']
})
export class FileEditorComponent implements OnInit {

	private _element = new FileInfo();
	@Input() set element( val: FileInfo ) {
		this._element = val;
		this.updateValueForm();
	}
	get element() {
		return this._element;
	}
	formG1: UntypedFormGroup = this._fb.group({});
	myInputs: { [name: string]: DataInput } = {};

	@Output() done = new EventEmitter<FileInfo>();

	// fileToUpload?: File = undefined;

    filetypesAccepted = ['.eml', '.pdf', '.jpeg', '.jpg', '.gif', '.png', '.mp4', '.avi', '.mov', '.wmv', '.3gp'].sort();


	constructor(
		public requestInProgressService: RequestInProgressService,
		private _fb: UntypedFormBuilder,
		// private _fm: FormManagementService,
		private oldFileService: OldFileService,
		@Inject('environment') private environment: Environment,
	) {}

	async ngOnInit() {
		console.log( 'FILE-EDITOR.component ngOnInit()')

		for( let dataInput of this.environment.file ) {
			this.myInputs[ dataInput.id ] = dataInput;
		}
		this.updateValueForm();
	}

	updateValueForm() {
		if( this.formG1.get( 'dlAllgemein') ) {	// the formgroup is already initialized
			this.formG1.reset();
			this.formG1.patchValue( this._element );

			const tms1 = this._element.dlGueltigAb;
			if( tms1 ) {
				const dt = new Date();
				dt.setTime( tms1 );
				// formatDate( tms1, "yyyy-MM-dd", "de-DE" );
				const str = dt.toISOString().slice( 0, 10 );
				this.formG1.get( "dlGueltigAb" )?.patchValue( str );
			}
			const tms2 = this._element.dlGueltigBis;
			if( tms2 ) {
				const dt = new Date();
				dt.setTime( tms2 );
				const str = dt.toISOString().slice( 0, 10 );
				this.formG1.get( "dlGueltigBis" )?.patchValue( str );
			}
		}
	}

	cancel() {
		this.done.emit( new FileInfo() );
	}

	reset() {
		console.log( 'reset()', this.formG1 )
		this.formG1.reset();
	}

	fileChosen( file: File ) {
		console.log( 'fileChosen', file )
		// if the file has already been uploaded then it can't be changed
		if( this._element.dlId ) return;

		console.log( 'fileToUpload', file.name )
		// this.fileToUpload = file;
		this.formG1.patchValue( { file: file } );
	}

	save() {

		const elementToSave: FileInfo = { ...this._element };

		const f = this.formG1.value;
		for( const field in this.myInputs ) {

			let value = f[ field ];

			if( this.myInputs[ field ].type == "date" ) {
				const dt = new Date( value );
				if( dt ) value = dt.getTime();
			}

			(elementToSave[ field as keyof FileInfo ] as any) = value;

		}


		elementToSave.dlAllgemein = true;


		if( !this._element.dlId ) {
			this.oldFileService.create( elementToSave, f.file ).subscribe( b => {
				if( b ) {
					this._element = elementToSave;
					this.done.emit(elementToSave);
				}
			});
		}
		else {
			this.oldFileService.update( elementToSave ).subscribe( b => {
				if( b ) {
					for( const property in elementToSave ) {
						this._element[ property ] = elementToSave[ property ];
					}
					this.done.emit(this._element);
				}
			});
		}


	}
}
